import React, { Fragment } from 'react';

import t from '../../../labels/labelling-utils';
import { FLAG, getFlag, placeholdersMap } from '../../../utils/placeholders-football';
import { makeClassNames } from '../../../utils/styles';
import { getAge } from '../../../utils/times';
import ImgPlaceholder from '../../atoms/img-placeholder/img-placeholder';
import Text from '../../atoms/text/text';

import './team-row.scss';

export interface ITeamRow {
  birthdate: string | null; // ISS-6012
  flag: string;
  fullname: string;
  height: number;
  jerseyNum: number;
  weight: number;
  playerPageLink?: string;
}

const classNames = () =>
  makeClassNames({
    row: 'team-row',
    number: 'team-row__number',
    country: 'team-row__country',
    flag: 'team-row__flag',
    name: 'team-row__name',
    data: 'team-row__data',
    span: 'team-row__span',
    cta: 'team-row__cta',
  });

const TeamRow = ({
  birthdate,
  fullname,
  /* istanbul ignore next: default value */ flag = 'unknown',
  /* istanbul ignore next: default value */ height = 0,
  /* istanbul ignore next: default value */ jerseyNum = 0,
  /* istanbul ignore next: default value */ weight = 0,
  playerPageLink,
}: ITeamRow) => {
  const cn = classNames();

  const flagUrl: string = getFlag(flag);
  const age: number = birthdate ? getAge(birthdate) : 0;
  const labelAge: string = age === 0 ? '-' : `${age} ${t('team.players.label.years')}`;
  const labelHeight: string = height === 0 ? '-' : `${(height / 100).toFixed(2).replace('.', ',')} m`;
  const labelWeight: string = weight === 0 ? '-' : `${weight} kg`;

  return (
    <Fragment>
      <tr className={cn.row}>
        <td className={cn.number}>
          <span className={cn.span}>{jerseyNum === 0 ? '-' : jerseyNum}</span>
        </td>
        <td className={cn.country}>
          <ImgPlaceholder
            src={flagUrl}
            className={cn.flag}
            loading="lazy"
            aria-hidden
            placeholder={placeholdersMap[FLAG]}
          />
        </td>
        <td className={cn.name}>
          <Text
            className={cn.cta}
            href={playerPageLink}
            tag={playerPageLink ? 'a' : 'span'}
            fontSize="14"
            fontWeight="500"
            color="blue"
          >
            {fullname}
          </Text>
        </td>
        <td className={cn.data}>
          <span className={cn.span}>{labelAge}</span>
        </td>
        <td className={cn.data}>
          <span className={cn.span}>{labelHeight}</span>
        </td>
        <td className={cn.data}>
          <span className={cn.span}>{labelWeight}</span>
        </td>
      </tr>
    </Fragment>
  );
};

export default TeamRow;
